<div
  class="flex w-[462px] flex-col gap-5 bg-surface-0 p-12 shadow-surface-200
    rounded-border"
  [class]="userStore.get().logged ? '' : 'shadow-xl'">
  <div>
    <h3 class="mb-2 font-medium text-surface-900" i18n>New Password</h3>
    <small class="font-medium text-surface-500" i18n>
      Please enter your new password.
    </small>
  </div>

  <form class="flex flex-col gap-3" [formGroup]="paswordForm">
    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon class="z-10">
          <ng-icon
            name="phosphorLockSimple"
            class="text-xl text-primary"></ng-icon>
        </p-inputicon>

        <p-password
          class="w-full"
          name="password"
          formControlName="password"
          toggleMask="true"
          fluid>
          <ng-template pTemplate="header">
            <div class="text-xm mb-4 font-semibold">Pick a password</div>
          </ng-template>
          <ng-template pTemplate="footer">
            <p-divider />
            <ul class="my-0 ml-2 pl-2 leading-normal">
              <li i18n>At least one lowercase</li>
              <li i18n>At least one uppercase</li>
              <li i18n>At least one numeric</li>
              <li i18n>Minimum 8 characters</li>
            </ul>
          </ng-template>

          <ng-template pTemplate="hideicon">
            <ng-icon
              name="phosphorEye"
              class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
          </ng-template>
          <ng-template pTemplate="showicon">
            <ng-icon
              name="phosphorEyeClosed"
              class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
          </ng-template>
        </p-password>
      </p-iconfield>
      <label for="password" i18n>New password</label>
    </p-floatlabel>

    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon class="z-10">
          <ng-icon
            name="phosphorLockSimple"
            class="text-xl text-primary"></ng-icon>
        </p-inputicon>

        <p-password
          class="w-full"
          name="confirmPassword"
          formControlName="confirmPassword"
          toggleMask="true"
          feedback="false"
          fluid>
          <ng-template pTemplate="hideicon">
            <ng-icon
              name="phosphorEye"
              class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
          </ng-template>
          <ng-template pTemplate="showicon">
            <ng-icon
              name="phosphorEyeClosed"
              class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
          </ng-template>
        </p-password>
      </p-iconfield>
      <label for="confirmPassword" i18n>Confirm new password</label>
    </p-floatlabel>

    <div>
      <small class="font-bold text-surface-500" i18n>Verification code</small>
      <small class="text-surface-500" i18n>
        We've sent the verification code via SMS to
        {{
          forgetPasswordPhoneNumber()
            ? (forgetPasswordPhoneNumber() | slice: -6)
            : 'your phone'
        }}
      </small>
    </div>

    <p-inputotp
      [integerOnly]="true"
      placeholder="0"
      class="!gap-2 self-center"
      [length]="6"
      formControlName="twoFA" />
  </form>

  <small class="flex items-center font-medium text-surface-900">
    <span
      *ngIf="countdown() > 0; else codeExpired"
      class="inline-flex items-center">
      Your code expires in:
      <ng-icon name="phosphorClock" class="ml-1 mr-1 text-xl"></ng-icon>
      {{ countdown() * 1000 | date: 'mm:ss' }}
    </span>
    <ng-template #codeExpired>
      <span class="text-red-500" i18n> Your code expired. </span>
      &nbsp;

      <a class="cursor-pointer text-secondary-700" (click)="resendCode()" i18n>
        Generate new code
      </a>
    </ng-template>
  </small>

  <div class="flex min-h-7 flex-col">
    <error-small-component></error-small-component>
    <caps-lock-component></caps-lock-component>
  </div>

  <div class="mt-4 flex gap-2">
    <button
      pButton
      pRipple
      [outlined]="true"
      label="Cancel"
      class="w-full !text-sm"
      (click)="clickCancel()"></button>
    <button
      pButton
      pRipple
      label="Save"
      class="w-full !text-sm"
      (click)="submit()"></button>
  </div>
</div>
